export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9466.5711f3cd.jpg";